import React from 'react';
import { MapPin, AlertTriangle, Clock, CheckCircle2 } from 'lucide-react';
import { Lead } from '../types';
import { eur, daysUntil } from '../lib/utils';
interface LeadCardProps {
  lead: Lead;
  onClick: () => void;
}
export function LeadCard({
  lead,
  onClick
}: LeadCardProps) {
  const days = daysUntil(lead.next);
  let flag = null;
  if (lead.next) {
    if (days < 0) {
      flag = <span className="badge-hot inline-flex items-center gap-1" data-id="element-57">
          <AlertTriangle className="w-3 h-3" strokeWidth={2.5} data-id="element-58" />
          Vencido {-days}d
        </span>;
    } else if (days === 0) {
      flag = <span className="badge-warn inline-flex items-center gap-1" data-id="element-59">
          <Clock className="w-3 h-3" strokeWidth={2.5} data-id="element-60" />
          Hoy
        </span>;
    } else if (days <= 2) {
      flag = <span className="badge-warn inline-flex items-center gap-1" data-id="element-61">
          <Clock className="w-3 h-3" strokeWidth={2.5} data-id="element-62" />
          En {days}d
        </span>;
    } else {
      flag = <span className="badge-ok inline-flex items-center gap-1" data-id="element-63">
          <CheckCircle2 className="w-3 h-3" strokeWidth={2.5} data-id="element-64" />
          En {days}d
        </span>;
    }
  }
  return <div onClick={onClick} className="bg-white border border-line rounded-xl p-3.5 mb-2.5 shadow-[0_2px_8px_-4px_rgba(43,43,43,0.12)] cursor-pointer hover:shadow-[0_8px_20px_-10px_rgba(43,43,43,0.25)] hover:-translate-y-0.5 hover:border-wood/30 active:scale-[0.98] transition-all" data-id="element-65">
      <div className="font-extrabold text-[14.5px] mb-1 text-charcoal leading-tight" data-id="element-66">
        {lead.name || '(sin nombre)'}
      </div>
      <div className="text-[12px] text-[#8a8175] flex flex-wrap items-center gap-x-2 gap-y-0.5 mb-2 font-medium" data-id="element-67">
        {lead.zone && <span className="inline-flex items-center gap-1" data-id="element-68">
            <MapPin className="w-3 h-3" strokeWidth={2.5} data-id="element-69" />
            {lead.zone}
          </span>}
        {lead.m2 && <span data-id="element-70">· {lead.m2} m²</span>}
      </div>
      {lead.value > 0 && <div className="font-poppins font-extrabold text-[14px] text-wood mb-1 tracking-tight" data-id="element-71">
          {eur(lead.value)}
        </div>}
      <div className="flex items-center justify-between mt-2 gap-1.5 flex-wrap" data-id="element-72">
        <span className="badge-src" data-id="element-73">{lead.src || '—'}</span>
        {flag}
      </div>
    </div>;
}